import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";
import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";
Vue.use(VueExcelEditor);

export default {
  name: 'mpMovimientos',
  mixins: [mixx],
  data() {
    return {
      data: [],
      loading: false,
      loading_f: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate(),
        estado: false
      }
    }
  },

  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  component: {
    VueExcelEditor
  },

  computed: {
    reporte: function () {
      return (
        "/billeteras/MP/movimientos?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: ['excelHtml5'],
    });
  },
  methods: {
    consultar() {
      this.loading = true;
      this.data = [];
      this.$http
        .post(
          "/billeteras/MP/movimientos", this.f_c)
        .then(response => {
          response.data.data.forEach(row => {
            row[8] = this.num_to_many(row[8]);
            row[9] = this.num_to_many(row[9]);
            row[10] = this.num_to_many(row[10]);
            row[11] = this.num_to_many(row[11]);
            row[12] = this.num_to_many(row[12]);
            row[13] = this.num_to_many(row[13]);
            row[14] = this.num_to_many(row[14]);
            row[15] = this.num_to_many(row[15]);
            row[16] = this.num_to_many(row[16]);
            this.tbv.row.add(row);
          });
          this.tbv.draw();
          this.loading = false;
        });
    },


  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/mpMovimientos/index.js